import { useTranslation } from 'react-i18next';
import {
  Button,
  Card,
  CardBody,
  CardHeader,
  Col,
  Container,
  Input,
  Label,
  Row,
  Spinner,
} from 'reactstrap';
import { useCrmChartsData } from './hooks/useCrmChartsData';
import Breadcrumbs from '../../../coreComponents/breadcrumbs';
import CrmChartsComponent from './CrmChartsComponent';
import { useCrmLeadsChartsData } from './hooks/useCrmLeadsChartsData';
import CommonCardHeader from '../../../coreComponents/CommonCardHeader';
import { useCloseWithReason } from './hooks/useCrmCloseUsersChartsData';
import DatePicker, { registerLocale, setDefaultLocale } from 'react-datepicker';
import { enGB, ru, uk } from 'date-fns/locale';

registerLocale('en', enGB);
registerLocale('uk', uk);
registerLocale('ru', ru);

const CrmCharts = () => {
  const { t, i18n } = useTranslation();
  const currentLocale = i18n.language || 'en';
  setDefaultLocale(currentLocale);
  const { from, setFrom, to, setTo, error, setError, loading, fetchData, chartsData, chartsLines } =
    useCrmChartsData();
  const {
    from: leadsFrom,
    to: leadsTo,
    setTo: setLeadsTo,
    setFrom: setLeadsFrom,
    error: leadsError,
    loading: leadsLoading,
    fetchData: fetchLeadsData,
    chartsData: leadsChartsData,
    chartsLines: leadsChartsLines,
  } = useCrmLeadsChartsData();

  const {
    from: closeFrom,
    to: closeTo,
    setTo: setCloseTo,
    setFrom: setCloseFrom,
    error: closeError,
    loading: closeLoading,
    fetchData: fetchCloseData,
    chartsDataLeads: closeChartsDataLeads,
    chartsLinesLeads: closeChartsLinesLeads,
    chartsDataEngagements: closeChartsDataEngagements,
    chartsLinesEngagements: closeChartsLinesEngagements,
  } = useCloseWithReason();

  console.log('CrmCharts render with data:', {
    closeChartsDataLeads,
    closeChartsLinesLeads,
    closeChartsDataEngagements,
    closeChartsLinesEngagements,
  });

  return (
    <>
      <Breadcrumbs mainTitle={t('control.crmCharts.title')} />
      <Container fluid className="default-dashboard">
        <Col xl="12" className="box-col-12 proorder-md-1">
          <Card className={`relative `}>
            <CommonCardHeader title={t('control.title')} tag />

            <CardBody className={`premium-card `}>
              <Row className="align-items-end g-3 mb-3">
                <Col md="3">
                  <Label className="form-label">{t('stats.from')}</Label>
                  {/* <Input type="date" value={from} onChange={(e) => setFrom(e.target.value)} />
                   */}
                  <DatePicker
                    className="form-control flatpickr-input"
                    selected={from ? new Date(from) : null}
                    onChange={(date) => setFrom(date ? date.toISOString().split('T')[0] : '')}
                    dateFormat="dd.MM.yyyy"
                    calendarStartDay={1}
                    locale={currentLocale}
                  />
                </Col>
                <Col md="3">
                  <Label className="form-label">{t('stats.to')}</Label>
                  {/* <Input type="date" value={to} onChange={(e) => setTo(e.target.value)} /> */}
                  <DatePicker
                    className="form-control flatpickr-input"
                    selected={to ? new Date(to) : null}
                    onChange={(date) => setTo(date ? date.toISOString().split('T')[0] : '')}
                    dateFormat="dd.MM.yyyy"
                    calendarStartDay={1}
                    locale={currentLocale}
                  />
                </Col>
                <Col md="2" className="pt-1">
                  <Button color="primary" onClick={() => fetchData(from, to)} disabled={loading}>
                    {loading ? <Spinner size="sm" /> : t('stats.refresh')}
                  </Button>
                </Col>
                {error && (
                  <Col md="12" className="text-danger">
                    {error}
                  </Col>
                )}
              </Row>

              <CrmChartsComponent data={chartsData} lines={chartsLines} />
            </CardBody>
          </Card>

          <Card className={`relative `}>
            <CommonCardHeader title={t('control.crmCharts.leadsCharts')} tag />
            <CardBody className={`premium-card `}>
              <Row className="align-items-end g-3 mb-3">
                <Col md="3">
                  <Label className="form-label">{t('stats.from')}</Label>
                  <DatePicker
                    className="form-control flatpickr-input"
                    selected={leadsFrom ? new Date(leadsFrom) : null}
                    onChange={(date) => setLeadsFrom(date ? date.toISOString().split('T')[0] : '')}
                    dateFormat="dd.MM.yyyy"
                    calendarStartDay={1}
                    locale={currentLocale}
                  />
                </Col>
                <Col md="3">
                  <Label className="form-label">{t('stats.to')}</Label>
                  {/* <Input type="date" value={leadsTo} onChange={(e) => setLeadsTo(e.target.value)} />
                   */}
                  <DatePicker
                    className="form-control flatpickr-input"
                    selected={leadsTo ? new Date(leadsTo) : null}
                    onChange={(date) => setLeadsTo(date ? date.toISOString().split('T')[0] : '')}
                    dateFormat="dd.MM.yyyy"
                    calendarStartDay={1}
                    locale={currentLocale}
                  />

                </Col>
                <Col md="2" className="pt-1">
                  <Button
                    color="primary"
                    onClick={() => fetchLeadsData(leadsFrom, leadsTo)}
                    disabled={leadsLoading}
                  >
                    {leadsLoading ? <Spinner size="sm" /> : t('stats.refresh')}
                  </Button>
                </Col>
                {leadsError && (
                  <Col md="12" className="text-danger">
                    {leadsError}
                  </Col>
                )}
              </Row>

              <CrmChartsComponent data={leadsChartsData} lines={leadsChartsLines} />
            </CardBody>
          </Card>

          <Card className={`relative `}>
            <CommonCardHeader title={t('control.crmCharts.leadsCloseCharts')} tag />
            <CardBody className={`premium-card `}>
              <Row className="align-items-end g-3 mb-3">
                <Col md="3">
                  <Label className="form-label">{t('stats.from')}</Label>
                  <DatePicker
                    className="form-control flatpickr-input"
                    selected={closeFrom ? new Date(closeFrom) : null}
                    onChange={(date) => setCloseFrom(date ? date.toISOString().split('T')[0] : '')}
                    dateFormat="dd.MM.yyyy"
                    calendarStartDay={1}
                    locale={currentLocale}
                  />
                </Col>
                <Col md="3">
                  <Label className="form-label">{t('stats.to')}</Label>
                  {/* <Input type="date" value={closeTo} onChange={(e) => setCloseTo(e.target.value)} /> */}
                  <DatePicker
                    className="form-control flatpickr-input"
                    selected={closeTo ? new Date(closeTo) : null}
                    onChange={(date) => setCloseTo(date ? date.toISOString().split('T')[0] : '')}
                    dateFormat="dd.MM.yyyy"
                    calendarStartDay={1}
                    locale={currentLocale}
                  />
                </Col>
                <Col md="2" className="pt-1">
                  <Button
                    color="primary"
                    onClick={() => fetchCloseData(closeFrom, closeTo)}
                    disabled={closeLoading}
                  >
                    {closeLoading ? <Spinner size="sm" /> : t('stats.refresh')}
                  </Button>
                </Col>
                {closeError && (
                  <Col md="12" className="text-danger">
                    {closeError}
                  </Col>
                )}
              </Row>

              <CrmChartsComponent data={closeChartsDataLeads} lines={closeChartsLinesLeads} />
            </CardBody>

            <CommonCardHeader title={t('control.crmCharts.engagementsCloseCharts')} tag />
            <CardBody className={`premium-card `}>
              <Row className="align-items-end g-3 mb-3">
                {closeError && (
                  <Col md="12" className="text-danger">
                    {closeError}
                  </Col>
                )}
              </Row>

              <CrmChartsComponent
                data={closeChartsDataEngagements}
                lines={closeChartsLinesEngagements}
              />
            </CardBody>
          </Card>
        </Col>
      </Container>
    </>
  );
};

export default CrmCharts;
